var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 8.25 3.54-3.54L0 1.18 1.18 0l4.71 4.71-4.71 4.72L0 8.25Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgArrow);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0wIDguMjUgMy41NC0zLjU0TDAgMS4xOCAxLjE4IDBsNC43MSA0LjcxLTQuNzEgNC43MkwwIDguMjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+Cjwvc3ZnPg==";